export default __webpack_public_path__ + "static/media/hot-7.4fc8eeb9.png";